<div class="container">
  <h2>Dimensões do Produto</h2>
  <div class="inputs">
    <label>
      Altura:
      <input type="number" [(ngModel)]="product.height" min="0">
    </label>
    <label>
      Largura:
      <input type="number" [(ngModel)]="product.width" min="0">
    </label>
    <label>
      Comprimento:
      <input type="number" [(ngModel)]="product.length" min="0">
    </label>
    <label>
      Peso:
      <input type="number" [(ngModel)]="product.weight" min="0">
    </label>
    <label>
      Quantidade de products:
      <input type="number" [(ngModel)]="product.quantity" min="1">
    </label>
    <div class="col-12 text-center pt-4">
      <app-spinner [show]="loading"></app-spinner>
      <p *ngIf="!loading && betterPackage?.length == 0">Nenhuma configuração encontrada.</p>
      <app-botao *ngIf="!loading" texto="Calcular Melhor Pacote" [executando]="loading"
        classe="button button-lg button-primary-outline" (clique)="calculateBetterPackage()">
      </app-botao>
      <div *ngIf="!loading && betterPackage?.length > 0">
        <h2>Pacotes Selecionados</h2>
        <div *ngFor="let pkg of betterPackage" class="package">
          <h3>Modelo: {{ pkg.model }}</h3>
          <p>Descrição: {{ pkg.description }}</p>
          <p>Dimensões: {{ pkg.width }} x {{ pkg.height }} x {{ pkg.length }} cm</p>
          <p>Itens neste pacote: {{ pkg.itemsInThisPackage }}</p>
        </div>
      </div>
    </div>
  </div>
  <h2>Lista de Configurações de Pacotes</h2>
  <ul>
    <li *ngFor="let box of boxes">
      <div class="box">
        <div class="modelo" [id]="box.Modelo">
          <img [src]="getImageModel(box.Modelo)" alt="{{ box.Modelo }}">
          <div class="dimensoes">
            <span class="largura">Largura: {{ box.Largura }}cm</span>
            <span class="altura">Altura: {{ box.Altura }}cm</span>
            <span class="comprimento">Comprimento: {{ box.Comprimento }}cm</span>
          </div>
        </div>
        <div class="ideal-para">
          <img [src]="getImageIdealTo(box.Modelo)" alt="Ideal para {{ box.IdealPara }}">
          <p>Ideal para: {{ box.IdealPara }}</p>
        </div>
      </div>
    </li>
  </ul>
</div>